export * from './ScanFrameBarcodeClassicIcon';
export * from './ScanFrameBarcodeClassicIcon16Light';
export * from './ScanFrameBarcodeClassicIcon16Regular';
export * from './ScanFrameBarcodeClassicIcon16Solid';
export * from './ScanFrameBarcodeClassicIcon20Light';
export * from './ScanFrameBarcodeClassicIcon20Regular';
export * from './ScanFrameBarcodeClassicIcon20Solid';
export * from './ScanFrameBarcodeClassicIcon24Regular';
export * from './ScanFrameBarcodeClassicIcon24Solid';
export * from './ScanFrameBarcodeClassicIcon32Regular';
export * from './ScanFrameBarcodeClassicIcon64Regular';
